import {Component, OnInit, OnDestroy} from '@angular/core';
import {Title} from '@angular/platform-browser';

import {ApiService} from '../services/api.service';
import {UserService} from '../user.service';
import {getProviderIconClass, getProviderMenuName, getProviderSettingsLink} from '../ProivderUtil';
import {static_links} from '../constants';

@Component({
    selector: 'iona-app',
    templateUrl: './account.component.html',
    viewProviders: []
})

export class AccountComponent implements OnInit, OnDestroy {

    refresh: any = [];

    /**
     * Provider Daten
     */
    provider: number = 0;
    providerclass: string = '';
    providername: string = '';
    privacyLink: '';
    providerMenuName: string = null;
    providerSettingsLink: string = null;
    username: string = null;

    version: string = '0.0.0';
    changelog: any = [];
    logs: boolean = false;

    constructor(private _titleService: Title,
                public _apiService: ApiService,
                private _userService: UserService) {
    }

    ngOnInit() {
        this.username = this._userService.getActiveUserName();
        this.providername = this._userService.getActiveUserProvider();
        this.privacyLink = static_links.privacy[this.providername];
        switch (this.providername.toLowerCase()) {
            case 'innogy':
                this._titleService.setTitle('Mein innogy | iONA');
                break;
            case 'enviam':
                this._titleService.setTitle('Meine enviaM | iONA');
                break;
            case 'eprimo':
                this._titleService.setTitle('Mein eprimo | iONA');
                break;
            case 'lew':
                this._titleService.setTitle('Meine LEW | iONA');
                break;
        }
        this.providerclass = getProviderIconClass(this.providername);
        this.providerMenuName = getProviderMenuName(this.providername);
        this.providerSettingsLink = getProviderSettingsLink(this.providername);

        this.getVersion();
        this.getChangelog();

        if (this._apiService.isDemoMode()) {
            return;
        }

        /**
         * Ist der Nutzer überhaupt eingeloggt? Wenn nicht, Weiterleitung zum Login
         */
        this._apiService.checkToken();
        this._apiService.checkMeterStatus();

        /**
         * Wiederkehrende Prüfung, ob der Nutzer eingeloggt ist
         */
        this.refresh = setInterval(() => {
            this._apiService.checkToken();
        }, 10000);
    }

    ngOnDestroy() {
        clearInterval(this.refresh);
    }

    getVersion() {
        this._apiService.getChangelog().subscribe(
            (data: any) => {
                if (0 in data) {
                    this.version = data[0].version;
                }
            }
        );
    }

    getChangelog() {
        this._apiService.getChangelog().subscribe(
            (data: any) => {
                this.changelog = data;
            }
        );
    }

    showChangelog() {
        this.logs = true;
    }

    hideChangelog() {
        this.logs = false;
    }

}
